import { CorsairDocumentType } from '@rygen/rygen-ui/model';

import { getContentTypeFor } from '@/util/FileUtil';

export class DocumentProperties {
  documentName: string;
  documentTypes: CorsairDocumentType[];
  fileName?: string;
  contentType?: string;
  contentLength?: number;

  constructor(opts?: Partial<DocumentProperties>) {
    this.documentName = opts?.documentName || '';
    this.documentTypes = opts?.documentTypes || [];
    this.fileName = opts?.fileName ?? this.documentName;
    this.contentType = opts?.contentType;
    this.contentLength = opts?.contentLength;
  }

  static fromFile(file: File, opts?: Partial<DocumentProperties>) {
    return new DocumentProperties({
      ...opts,
      // Filename is set through the document properties to be the GCP filename
      fileName: opts?.fileName,
      documentName: file.name,
      contentType: getContentTypeFor(file),
      contentLength: file.size,
    });
  }
}
